import PagedElements from '@/models/paged/pagedelements';
import SaleListViewModel from '@/models/view/salelistviewmodel';

export default class PagedSales extends PagedElements<SaleListViewModel> {
    constructor(init?: Partial<PagedSales>) { super(init); }
}
